import { getPageType } from 'Components/hooks/use-side-nav-status'
import makePubSubHook from 'Components/hooks/make-pub-sub-hook'

type HeaderTheme = 'default' | 'theater'

const defaultTheme: HeaderTheme = 'default'

const [setHeaderTheme, useHeaderTheme] = makePubSubHook<HeaderTheme>('default')

export { setHeaderTheme }

function getHeaderThemeByPageType(): HeaderTheme {
  const pageType = getPageType()
  if (!pageType) {
    return defaultTheme
  }
  if (pageType.indexOf('theater') > -1) {
    return 'theater'
  }
  return defaultTheme
}

export function resetHeaderTheme() {
  setHeaderTheme(getHeaderThemeByPageType())
}

export default useHeaderTheme
